import { render, staticRenderFns } from "./RiderPerformanceReport.vue?vue&type=template&id=22e367d4&"
import script from "./RiderPerformanceReport.vue?vue&type=script&lang=js&"
export * from "./RiderPerformanceReport.vue?vue&type=script&lang=js&"
import style0 from "./RiderPerformanceReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports